import React, { useCallback } from "react";

import { faStopwatch } from "@fortawesome/pro-light-svg-icons/faStopwatch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import useCalendarContext from "@app/scene/activity/component/ActivityCalendarPage/utils/useCalendarContext";

import styles from "./Cadence.module.scss";
import SuggestionProps from "./SuggestionProps";

const CadenceSuggestion: React.FC<SuggestionProps> = ({ suggestion }) => {
  const intl = useIntl();

  const { onCadenceClick } = useCalendarContext();

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      onCadenceClick?.(suggestion);
    },
    [suggestion, onCadenceClick]
  );

  return (
    <div className={styles.container} onClickCapture={handleClick}>
      <div className={styles.text}>
        {intl.formatMessage(
          {
            id: "activities.calendarView.events.suggestion.frequency.title",
            defaultMessage: "{count} {count, plural, one {record} other {records}} due to be seen",
          },
          { count: suggestion.count }
        )}
      </div>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={faStopwatch} />
      </div>
    </div>
  );
};

export default CadenceSuggestion;
